import { useService } from "@/base/hooks/useService";
import { StorageService } from "@services/StorageService";
import { localstorageKeys } from "@const/store";

const useClearOldStorageKeys = (keyVersion) => {
  const storageService = useService(StorageService);
  const keys = storageService.get(localstorageKeys.keysVersion, "");
  const session = storageService.get(localstorageKeys.session, "");
  const tourFinished = storageService.get(localstorageKeys.tourFinished, "");

  if (keys === keyVersion) {
    return;
  }

  storageService.clear();
  storageService.set(localstorageKeys.keysVersion, keyVersion);
  storageService.set(localstorageKeys.session, session);
  storageService.set(localstorageKeys.tourFinished, tourFinished);
};

export default useClearOldStorageKeys;
